import { useDispatch } from 'react-redux';
import * as $ from 'jquery';
import { labOrderEdit, labOrderLoad } from '../../../../../../redux/actions/order/labOrderActions';

export default function LabOrderButton(props) {
  const { resourceId, labOrderId, children } = props;
  const dispatch = useDispatch();

  const handleLabOrderOpen = () => {
    dispatch(labOrderEdit(resourceId));
    if (labOrderId)
      dispatch(labOrderLoad(labOrderId))
    $(`#labOrderForm-${resourceId}-modal`).modal();
  }

  return (
    <span className="pointer" onClick={handleLabOrderOpen}>
      {children}
    </span>
  )
}